import {useSelector} from 'react-redux';
import Page404 from '../page404/Page404';
import { DemoApp } from '@tickchak/react-share/demo';
import '@tickchak/react-share/demo/index.css';

function ReactShareDemo() {
    const isMaster = useSelector((s) => s.user?.isMaster);

    if (!isMaster) {
        return <Page404 eidParam={''} pidParam={''} />;
    }

    return (
        <div data-testid='react-share-demo' style={{overflow: 'auto', height: '100vh'}}>
            <DemoApp />
        </div>
    );
};

export default ReactShareDemo;
